module.exports = __webpack_public_path__ + "img/supplier.3dab2dff.png";